import { SBox, SCol, SRow } from "@avalara/skylab-sdk/react";
import React, { useContext, useEffect } from "react";
import { testIDs } from "../../../end-to-end-tests/constants/testIDs";
import { NavigationVisibilityContext } from "../navigation/NavigationVisibilityProvider";
import "./assets/error.css";
import { NoAccessErrorPageProps } from "./types";
import { getAssetURL } from "../../shared/Utils";

const NoAccessErrorPage = React.memo(({ traceId }: NoAccessErrorPageProps) => {
    const backgroundPath = getAssetURL("BackgroundNoAccess.svg");

    const { setHideHeader } = useContext(NavigationVisibilityContext);

    useEffect(() => {
        if (setHideHeader) (setHideHeader as (hide: boolean) => void)(true);
        return () => {
            if (setHideHeader) (setHideHeader as (hide: boolean) => void)(false);
        };
    }, [setHideHeader]);

    return (
        <div
            className={`flex dl-flex-fill-height dl-scroll dl-background`}
            style={{
                backgroundImage: `url(${backgroundPath})`,
            }}
            data-testid={testIDs.shared.noAccess}>
            <SRow>
                <SCol className="box-css text-center">
                    <SBox>
                        <div className="pad-all-lg" id="errorMessage">
                            <span>
                                <img
                                    src={getAssetURL("Keys.svg")}
                                    alt="Not Found"
                                    className="pad-right-lg"
                                />
                            </span>
                            <span className="float-right">
                                <h1 className="font-bold">
                                    <span>You don&apos;t have permission to</span>
                                    <br />
                                    <span className="header-text">view this page</span>
                                </h1>
                                <span>
                                    Your account administrator can update your permissions. If you
                                    <br /> think this message is appearing by mistake,{" "}
                                    <a
                                        className="pad-right-xs"
                                        href="https://www.avalara.com/us/en/about/support.html">
                                        contact support
                                    </a>
                                </span>
                            </span>
                        </div>
                        <div className="text-right text-xs" hidden={traceId == null}>
                            Trace ID: {traceId}
                        </div>
                    </SBox>
                </SCol>
            </SRow>
        </div>
    );
});

NoAccessErrorPage.displayName = "NoAccessErrorPage";

export default NoAccessErrorPage;
